<template>
  <div class="sku-select-popup-desktop">
    <slot name="img" />

    <div class="sku-select-popup-desktop__info">
      <slot name="title" />
      <slot name="sku-selectors" />
      <slot name="price-block" />

      <div class="sku-select-popup-desktop__info__button">
        <slot name="button" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="stylus">
.sku-select-popup-desktop
  width 700px
  display grid
  gap 32px
  grid-template-columns 290px 1fr

  &__info
    display flex
    flex-direction column
    gap 24px

    &__button
      position sticky
      bottom 0
      padding-top 12px
      margin-top  -12px
      background-color #FFFFFF
</style>
